// src/directives/on-exist.js

/*

<div v-on-exist>
    This element is monitored by the directive.
</div>

*/
export default {
  inserted: function inserted(el, binding) {
    // console.log('this is a test directive: WORKS')
    // Guard clause if template attributes are completely missing
    if (!binding || !binding.value) return;
    var _binding$value = binding.value,
        callback = _binding$value.callback,
        xid = _binding$value.xid,
        poll = _binding$value.poll;
    var isPolisDetected = false;

    var checkForPolis = function checkForPolis() {
      var polisDiv = el.querySelector('.polis');

      if (polisDiv && !isPolisDetected) {
        isPolisDetected = true;

        if (typeof callback === 'function') {
          callback(polisDiv, {
            xid: xid,
            poll: poll
          });
        }
      } else if (!polisDiv && isPolisDetected) {
        isPolisDetected = false;
      }
    }; // 1. Initial structural scan on mount


    checkForPolis(); // 2. Setup structural tracking

    el._domObserver = new MutationObserver(function () {
      checkForPolis();
    });

    el._domObserver.observe(el, {
      childList: true,
      subtree: true
    });
  },
  unbind: function unbind(el) {
    if (el._domObserver) {
      el._domObserver.disconnect();

      delete el._domObserver;
    }
  }
};